import React from 'react';
import { Alert, Button, Card, Form, Input } from 'antd';
import styles from '@/components/login/login.module.less';
import { LoginLayout } from '@/layouts';
import request from '@/utils/request';
import { Link } from 'react-router-dom';
import { PASSWORD_REGEXP } from '@/const/Validate';
import usePasswordEncrypt from "../../hooks/usePasswordEncrypt";
import { useUserInfo } from "../../hooks";

function ChangePasswordPage(props) {
  const [form] = Form.useForm();
  const { changePasswordEncrypt } = usePasswordEncrypt();
  const useInfo = useUserInfo();

  function handleSubmit() {
    form.validateFields().then((values) => {
      changePasswordEncrypt({ ...values, username: useInfo.username }).then((newValue) => {
        request.postWMessage('system-user-s-023', newValue).then(() => {
          props.history.replace('/');
        });
      });
    });
  }

  return (
    <LoginLayout>
      <Card bordered={false} className={styles.modifyCard} title="默认密码修改">
        <Form form={form} {...props.formItemLayout}>
          <Form.Item wrapperCol={{ offset: 6 }}>
            <Alert
              // message="请修改默认密码后使用苏采云平台，密码要求位数不小于8位，同时包含数字、大小写。"
              message="请修改默认密码，密码要求长度8~20位，必须包含大小写字母、数字及字符，字符包含~!@#$%^&*()_+`。"
              type="info"
              showIcon
              style={{ width: 600 }}
            />
          </Form.Item>
          <Form.Item
            name="oPassword"
            label="当前密码"
            rules={[{ required: true, message: '请输入当前密码!' }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="nPassword"
            label="新密码"
            hasFeedback
            dependencies={['oPassword']}
            rules={[
              {
                required: true,
                message: '请输入新密码',
              },
              {
                message: '请输入8到20位(含数字、大小写字母、字符)密码',
                pattern: PASSWORD_REGEXP,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value && value === getFieldValue('oPassword')) {
                    return Promise.reject('新旧密码不能相同');
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirm"
            dependencies={['nPassword']}
            label="确认密码"
            hasFeedback
            rules={[
              { required: true, message: '请输入确认密码!' },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('nPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject('您两次输入的密码不一致, 请重新输入!');
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8 }}>
            <Button onClick={handleSubmit} style={{ marginRight: 16 }} type="primary">
              提交
            </Button>
            <Link to="/loginOnlineMall">
              <Button>退出</Button>
            </Link>
          </Form.Item>
        </Form>
      </Card>
    </LoginLayout>
  );
}

ChangePasswordPage.propTypes = {};

ChangePasswordPage.defaultProps = {
  formItemLayout: {
    labelCol: { span: 8 },
    wrapperCol: { span: 10 },
  },
};

export default ChangePasswordPage;
